/**
 * Created by GSP on 7/01/2016.
 */
define('itemPagesNameMixin',['module'], function (module) {
  'use strict';

  var ItemPagesNameMixin = {
    ACCOUNT: 'account',
    MY_ACCOUNT: 'account_account',
    GRAPHICAL_ID: 'account_graphicalid',

    //MAILS
    MAILS: 'mails',

    //THREADS
    THREADS: 'threads',

    //WEBSHOP
    WEBSHOP: 'webshop',
    WEBSHOP_PRODUCTS: 'webshop_products',
    WEBSHOP_PRODUCTS_CATEGORIES: 'webshop_products_categories',
    WEBSHOP_CATEGORIES: 'webshop_categories',
    WEBSHOP_LANDINGPAGES: 'webshop_landingpage',
    WEBSHOP_FILTERS: 'webshop_filters',
    WEBSHOP_ATTRIBUTES: 'webshop_attributes',
    WEBSHOP_QUOTATIONS: 'webshop_quotations',
    WEBSHOP_MENU: 'webshop_menu',

    // PIM
    PIM: 'pim',
    PIM_PRODUCTS: 'pim_products',
    PIM_PRODUCT_ATTRIBUTES: 'pim_product_attributes',
    PIM_SEARCH: 'pim_search',
    PIM_OFFER_CONFIG_CHECK: 'pim_offer_config_check',

    // PRODUCTS
    PRODUCTS: 'products',
    MY_PRODUCTS: 'products_products',
    PRODUCTS_SUPPLIER: 'products_productsSupplier',
    PRODUCTS_PRICELISTS: 'products_pricelists',
    // Catalogs
    PRODUCTS_CATALOGS: 'products_catalogs',

    //CLIENTS
    CLIENTS: 'customers',
    MY_CLIENTS: 'customers_customers',
    MY_LEADS: 'customers_leads',
    PROSPECTION: 'customers_prospection',
    API_GRAPHICAL_REQUESTS: 'account_api_graphical_requests',
    COMPANIES: 'customers_companies',

    //ORDERS
    ORDERS: 'orders',
    ORDERS_BOARD: 'orders_board',
    ORDERS_LIST: 'orders_list',
    ORDERS_UNPAID: 'orders_unpaid',
    ORDERSTATUS: 'orderstatus',
    TRACKING: 'tracking',

    //OFFERS
    OFFERS: 'offers',
    OFFERS_BOARD: 'offers_board',
    OFFERS_LIST: 'offers_list',

    //SUPPLIERS
    SUPPLIERS: 'suppliers',
    SUPPLIERS_PRODUCTS: 'suppliers_products',
    SUPPLIERS_IMPRINT_TECHNOLOGIES: 'suppliers_imprint_technologies',
    SUPPLIERS_PORTAL_USERS: 'suppliers_portal_users',

    //GRAPHICAL REQUESTS
    GRAPHICALREQUESTS: 'graphicalRequests',
    GRAPHICAL_SERVICE_KANBAN: 'graphical_service_kanban',
    GRAPHICALREQUESTS_ALL_IN_ONE: 'graphicalRequests_all_In_One',
    GRAPHICALREQUESTS_VECTORIZATION: 'graphicalRequests_vectorization',
    GRAPHICALREQUESTS_FILECONVERSION: 'graphicalRequests_fileConversion',
    GRAPHICALREQUESTS_REMOVEBACKGROUND: 'graphicalRequests_RemoveBackground',

    //ADMIN
    ADMIN: 'admin',
    ADMIN_TRANSLATIONS: 'admin_translations',
    ADMIN_TIMETRACKING: 'admin_timeTracking',
    ADMIN_WORK_ACTIVITY: 'admin_workActivity',
    ADMIN_API_STATS: 'admin_apiStats',
    ADMIN_QRCODE_GENERATOR: 'admin_qrCodeGenerator',
    ADMIN_SUBACCOUNTS: 'subAccountCreator',
    ADMIN_IMPRINT_TECHNOLOGIES: 'admin_imprintTechnologies',
    ADMIN_HTMLTEMPLATES: 'admin_htmlTemplates',
    ADMIN_PHRASES: 'admin_phrases',
    ADMIN_IMPRINT_GLOSSARIES: 'admin_glossaries',
    ADMIN_WEBHOOK_HISTORY: 'admin_webhookHistory',
    ADMIN_USER_GROUPS: 'admin_userGroups',
    ADMIN_EMAIL_ADDRESSES: 'admin_emailAddresses',
    ADMIN_SNIPPETS: 'admin_snippets',
    ADMIN_GENERIC_EMAIL_DOMAINS: 'admin_genericEmailDomains',
    ADMIN_COLOR_SELECTIONS: 'admin_colorSelections',
    SALES: 'sales',
    CRM: 'crm',
    SALES_INBOX: 'sales_inbox',
    SALES_INBOX_WORKLIST: 'sales_inbox_worklist',
    SALES_INBOX_STATS: 'sales_inbox_stats',
    SALES_INBOX_ROUTING: 'sales_inbox_routing',
    SALES_INBOX_AUTO_RESOLVE: 'sales_inbox_auto_resolve',
    SUPPORT: 'support',
    SUPPORT_INBOX: 'support_inbox',
    SUPPORT_INBOX_WORKLIST: 'support_inbox_worklist',
    SUPPORT_INBOX_STATS: 'support_inbox_stats',
    CHAT_INBOX: 'chat_inbox',
    MAILING: 'mailing',
    MAILING_CAMPAIGNS: 'mailing_campaigns',
    MAILING_PERSONALISED: 'mailing_personalised',
    MAILING_WORKFLOWS: 'mailing_workflows',
    MAILING_TEMPLATES: 'mailing_templates',
    MAILING_SEGMENTS: 'mailing_segments',
    MAILING_SUBSCRIBERS: 'mailing_subscribers',
    MAILING_QUEUE: 'mailing_queue',
    MAILING_SETTINGS: 'mailing_settings',
    ADMIN_TASKS: 'admin_tasks',
    CALENDAR: 'calendar',
    ADMIN_NOTIFICATIONS: 'admin_notifications',
    ADMIN_NOTIFICATIONS_PREFERENCES: 'admin_notifications_preferences',
    ACCOUNTCREATOR: 'ACCOUNTCREATOR',
    ACCOUNTSHARECREATOR: 'ACCOUNTSHARECREATOR',
    TIMETRACKER: 'TIMETRACKER',
    SUPERADMIN_STATS: 'SUPERADMIN_STATS',
    COLLECTIONS: 'COLLECTIONS',
    ADMIN_MY_WEBSITE: 'MYWEBSITE',

    PHONE_CALLS: 'phone_calls',
    PHONE_NUMBERS: 'phone_numbers',

    //SUPER ADMIN
    SUPERADMIN: 'SUPERADMIN',
    SUPERADMIN_OVERVIEW: 'superAdmin_overview',
    SUPERADMIN_CACCOUNTS: 'superAdmin_cAccounts',

    INVITATIONS: 'invitations'
  };

  module.exports = ItemPagesNameMixin;
});
